export const TYPE_MODALITY_FN = {
    compre_ja: (ctx, plate) => ctx.natigateToBuyNowCompletedPurchasesClosedPage(null, plate),
    propostas_aceitas: (ctx, plate) => ctx.natigateToProposalCompletedPurchasesClosedPage(plate),
    cotacoes: (ctx, plate) => ctx.natigateToQuotesCompletedPurchasesClosedPage(plate),
    lances: (ctx, plate) => ctx.natigateToAnnouncementCompletedPurchasesClosedPage(plate),
    autobid: (ctx, plate) => ctx.natigateToAutoBidCompletedPurchasesClosedPage(plate),
    avaliacoes_sob_aprovacao: (ctx, plate) => ctx.natigateToOnDemandAssessmentCompletedPurchasesPage(plate),
};